import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page flex-col",
  id: "eco_body"
}
const _hoisted_2 = { class: "block_1 flex-row" }
const _hoisted_3 = { class: "section_1 flex-col" }
const _hoisted_4 = { class: "group_1 flex-row justify-between" }
const _hoisted_5 = { class: "box_1 flex-row" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "group_2 flex-row justify-between" }
const _hoisted_8 = { class: "box_2 flex-col" }
const _hoisted_9 = { class: "box_3 flex-row" }
const _hoisted_10 = { class: "image-wrapper_1 flex-col" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "group_3 flex-row" }
const _hoisted_13 = { class: "image-wrapper_2 flex-col" }
const _hoisted_14 = ["src"]

import { nextTick } from 'process';
import { reactive, ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'second',
  setup(__props) {

nextTick(()=>{
    let dom = document.querySelector('#eco_body') as any
    dom.style.zoom = 0.75
})
const getIcon = (n: number) => {
    if (!n) n = 1
    return require(`@/assets/images/eco-friendly/icon (${n}).png`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-wrapper_1 flex-col justify-between" }, [
            _createElementVNode("span", { class: "text_1" }, "开封市城乡一体化示范区"),
            _createElementVNode("span", { class: "text_2" }, "工业企业污染防治学习平台")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("input", {
              class: "input_class",
              placeholder: "2023年河南开封绩效分级查询"
            }, null, -1)),
            _createElementVNode("img", {
              class: "label_1",
              referrerpolicy: "no-referrer",
              src: getIcon(10)
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text_4" }, "环境影响评价", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "thumbnail_1",
                  referrerpolicy: "no-referrer",
                  src: getIcon(17)
                }, null, 8, _hoisted_11)
              ])
            ]),
            _cache[3] || (_cache[3] = _createStaticVNode("<span class=\"text_5\" data-v-055db1d4>法律法规</span><span class=\"text_6\" data-v-055db1d4>建设项目环境影响评价分类...</span><span class=\"text_7\" data-v-055db1d4>报告书、表</span><span class=\"text_8\" data-v-055db1d4>登记表备案</span><span class=\"text_9\" data-v-055db1d4>竣工环境保护验收</span><span class=\"text_10\" data-v-055db1d4>环境影响后评价</span>", 6))
          ]),
          _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"box_4 flex-col\" data-v-055db1d4><div class=\"text-wrapper_2 flex-row\" data-v-055db1d4><span class=\"text_11\" data-v-055db1d4>文件名称</span><span class=\"text_12\" data-v-055db1d4>访问次数</span><span class=\"text_13\" data-v-055db1d4>操作</span></div><div class=\"text-wrapper_3 flex-row\" data-v-055db1d4><span class=\"text_14\" data-v-055db1d4>环境影响评价（环评）是什么？</span><span class=\"text_15\" data-v-055db1d4>2478</span><span class=\"text_16\" data-v-055db1d4>在线预览</span><span class=\"text_17\" data-v-055db1d4>下载</span></div><div class=\"box_5 flex-col\" data-v-055db1d4></div><div class=\"text-wrapper_4 flex-row\" data-v-055db1d4><span class=\"text_18\" data-v-055db1d4>中华人民共和国环境影响评价法</span><span class=\"text_19\" data-v-055db1d4>29</span><span class=\"text_20\" data-v-055db1d4>在线预览</span><span class=\"text_21\" data-v-055db1d4>下载</span></div><div class=\"box_6 flex-col\" data-v-055db1d4></div><div class=\"text-wrapper_5 flex-row\" data-v-055db1d4><span class=\"text_22\" data-v-055db1d4>建设项目环境保护管理条例</span><span class=\"text_23\" data-v-055db1d4>888</span><span class=\"text_24\" data-v-055db1d4>在线预览</span><span class=\"text_25\" data-v-055db1d4>下载</span></div><div class=\"box_7 flex-col\" data-v-055db1d4></div></div>", 1))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text_26" }, "排污许可证", -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "thumbnail_2",
              referrerpolicy: "no-referrer",
              src: getIcon(3)
            }, null, 8, _hoisted_14)
          ])
        ])
      ])
    ])
  ]))
}
}

})